import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-minimize",
  "use": "oc-minimize-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-minimize\"><path d=\"M923.757893 878.861737h-824.195122a35.515317 35.515317 0 0 1-35.475356-35.475357V182.25202a35.515317 35.515317 0 0 1 35.475356-35.475357h824.195122a35.505327 35.505327 0 0 1 35.465366 35.475357v661.13436a35.505327 35.505327 0 0 1-35.465366 35.475357z m-795.712937-63.937561h767.250732v-604.209952h-767.250732z\" /><path d=\"M121.920937 210.354576H908.113171v119.882926H121.920937z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol